import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";
import { Link } from "react-router-dom";

import { openCookieSettings } from "@/components/landing/CookieConsent";
import { Seo } from "@/components/landing/Seo";
import { FinalCta, LandingNav, useReveal } from "@/components/landing/Sections";

const EMAIL_RGPD = <mark className="lp-todo">[EMAIL RGPD]</mark>;

export default function PrivacyPage() {
  useReveal();
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <div className="lp" data-testid="privacy-page">
      <Seo path="/politique-de-confidentialite" />
      <LandingNav />
      <main className="lp-legalpage lp-wrap">
        <Link to="/" className="lp-legalpage-back" data-testid="privacy-back"><ArrowLeft size={14} />Retour à l'accueil</Link>
        <h1>Politique de confidentialité</h1>
        <section>
          <h2>Responsable du traitement</h2>
          <p>AIRTHERMO, cabinet de courtage en énergie, SIREN 940 278 740, 5 allée de la Grande Treille, 35200 Rennes.</p>
        </section>
        <section>
          <h2>Données collectées</h2>
          <p>Via nos formulaires d'étude et de rappel : nom et prénom, téléphone, adresse e-mail, organisation, type de bâtiment, message écrit ou vocal. Ces informations sont fournies volontairement par vous.</p>
        </section>
        <section>
          <h2>Finalités et base légale</h2>
          <p>Vos données servent uniquement à réaliser l'étude d'éligibilité de votre projet aux Certificats d'Économies d'Énergie et à vous recontacter dans le cadre d'un rappel commercial. Le traitement repose sur votre consentement, recueilli par la case à cocher du formulaire.</p>
        </section>
        <section>
          <h2>Destinataires</h2>
          <p>Les données sont destinées à AIRTHERMO et à ses conseillers et, si vous donnez suite à l'étude, à l'installateur partenaire RGE chargé de votre projet. Elles ne sont ni vendues ni cédées à des tiers à des fins commerciales.</p>
        </section>
        <section>
          <h2>Durée de conservation</h2>
          <p>Vos données sont conservées 3 ans après notre dernier contact, puis supprimées.</p>
        </section>
        <section>
          <h2>Vos droits</h2>
          <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et de suppression de vos données, ainsi que d'un droit d'opposition et de limitation du traitement. Pour les exercer : {EMAIL_RGPD}. Vous pouvez aussi introduire une réclamation auprès de la CNIL (cnil.fr).</p>
        </section>
        <section>
          <h2>Cookies</h2>
          <p>Les cookies de mesure d'audience et de publicité (Google Analytics, Google Ads, LinkedIn) ne sont déposés qu'après votre accord. Vous pouvez modifier vos choix à tout moment : <button type="button" className="lp-linkbtn" onClick={openCookieSettings} data-testid="privacy-cookie-settings">gérer les cookies</button>.</p>
        </section>
      </main>
      <FinalCta />
    </div>
  );
}
